import React, { useContext }  from "react";
import { Box, Flex, Spacer, Button, useToast, Link as ChakraLink, Heading, Image, useBreakpointValue } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ApplicationContext } from "../utils/contextsProviders";
import mobileLogo from '../assets/mobileLogo.png';
import pcLogo from '../assets/pcLogo.png';
import ThinkqueLogo from '../assets/Thinkque_Logo.png'

const Header = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const toast = useToast();
  const { user } = useContext(ApplicationContext)
  const location = useLocation();
  const isValidRoutes = location.pathname === '/' || location.pathname === '/users';

  const handleLogout = () => {
    localStorage.removeItem("token");
    toast({
      title: "Logged out.",
      description: "You have been logged out successfully.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    navigate("/login");
  };
  
  const logo = useBreakpointValue({ base: mobileLogo, md: pcLogo });

  return (
    <Box bg="black" p={{ base: "12px", md: 4 }}>
      <Flex align="center" direction={{ base: "column", md: "row" }}  justifyContent={"space-between"}>
        <Flex align="center" justifyContent={"space-between"} width={{base:'100%', md:"auto"}}>
          <Image src={logo} alt="Logo" width={{base:'150px', md:'200px'}}/>
          {
            (user?.role === "CustomerAdmin" || user?.role === "SuperAdmin") && isValidRoutes ? 
          <Box>
            <ChakraLink as={RouterLink} to="/" color="white" mr={4} ml={4} textDecoration={location.pathname === '/' ? 'underline' : 'unset'}>
              Charts
            </ChakraLink>
            <ChakraLink as={RouterLink} to="/users" color="white" textDecoration={location.pathname === '/users' ? 'underline' : 'unset'}>
              Users
            </ChakraLink>
          </Box>
          : ''
          }
        </Flex>
        {token && <Image src={ThinkqueLogo} alt="Logo" width={{base:'150px', md:'200px'}}/>}
        {token && (
          <Flex align="center" justifyContent={"space-between"} width={{base:'100%', md:"auto"}}>
          <Heading color={"white"} mr={5} fontWeight={500} size={"sm"}>{`Customer Account: NZCE`}</Heading> 
          {/* <Heading size={"md"}>{`Customer Account: ${user.company_name}`}</Heading> */}
          <Button _hover={{ backgroundColor:"transparent", color: "white", border: "2px solid white" }} backgroundColor={'transparent'} color={'white'} border={'2px solid white'} borderRadius={"5px"} onClick={handleLogout}>
            Logout
          </Button>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default Header;
